$(document).on("click", ".quantityDecrease", function (e) {
  e.preventDefault();
  let current_val = parseInt(
    $(this).closest(".quantitySelector").find(".quantity").html()
  );
  if (current_val > 0) {
    $(this).html($('.spin-icon').html());
    updateCart($(this).data('id'), current_val - 1);
  }
});

$(document).on("click", ".quantityIncrease", function (e) {
  e.preventDefault();
  let current_val = parseInt(
    $(this).closest(".quantitySelector").find(".quantity").html()
  );
  $(this).html($('.spin-icon').html());
  updateCart($(this).data('id'), current_val + 1);
});

$(document).on("click", ".cartDelete", function (e) {
  e.preventDefault();
  $(this).html($('.spin-icon').html());
  updateCart($(this).data('id'), 0);
});

$(document).on("change", ".msgCheckbox input", function (e) {
  if ($(this).prop('checked')) {
    $('.msgCheckbox textarea').fadeIn();
  } else {
    $('.msgCheckbox textarea').fadeOut().val('').trigger('change');
  }
});

$(document).on("click", ".is-visible.cart-drawer-section .cart__background, .cart-close", function (e) {
  e.preventDefault();
  closeCart();
});

$(document).on("click", '[href="/cart"]', function (e) {
  e.preventDefault();
  openCart();
});

// New functionality for recommended products - Add small loading circle when clicking "Add"
$(document).on("click", ".compl-pro button", function (e) {
  e.preventDefault();
  
  let button = $(this);
  let itemId = $(this).data('id');
  
  // Show loading icon in place of the button text
  button.html($('.spin-icon').html());
  
  addItemToCart(itemId, button);  // Pass button element to revert it after loading
});

function openCart() {
  $('.cart-drawer-section').addClass('is-visible');
  $('body').css('overflow', 'hidden');
}

function closeCart() {
  $('.cart-drawer-section').removeClass('is-visible');
  $('body').css('overflow', 'auto');
}

function addItemToCart(id, button = null) {
  let formData = {
    'items': [{
      'id': id,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    rebuildCart();
    if (button) {
      button.html('Add');  // Revert button text after the item is added
    }
  })
  .then(() => {
    debouncedUpdateBucketListProgress();  // Debounced progress update
  })
  .catch((error) => {
    console.error('Error:', error);
    if (button) {
      button.html('Add');  // Revert button text on error as well
    }
  });
}

function updateCart(id, qty) {
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', "updates[" + id + "]=" + qty)
  .done(function () {
    rebuildCart();
    updateBucketListProgress(); // Ensure bucket list message updates after rebuild
  })
  .fail(function (e) {
    console.log(e);
  });
}

function addNote(note) {
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', "note=" + note)
  .done(function (e) {
    console.log(e);
  })
  .fail(function (e) {
    console.log(e);
  });
}

function rebuildCart() {
  fetch('/cart')
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var cartData = doc.querySelector('form#CartDrawerForm');
      $('.cart-drawer-rebuild').html(cartData);

      // Call debounced update for smooth progress bar and message
      debouncedUpdateBucketListProgress();
    })
    .catch(function (err) {
      console.warn('Something went wrong.', err);
    });
}

// Debounce function to prevent multiple rapid calls
function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}